import { Injectable, EventEmitter } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { AccountService } from './account.service';

@Injectable({providedIn:'root'})
export class Principal {
    private userIdentityPromise: Promise<any>;
    userIdentity: any;
    private authenticated = false;
    private _authenticatedUserId = 0;

    authenticationStateChange: EventEmitter<any> = new EventEmitter();

    constructor(
        private account: AccountService
    ) {}

    authenticate(identity) {
        const stateChange = (identity != this.userIdentity);
        this.userIdentityPromise = null;
        this.userIdentity = identity;
        this._authenticatedUserId = identity?identity.id:null;
        this.authenticated = (identity != null);
        if(stateChange) this.authenticationStateChange.emit(identity);
    }

    isAuthenticated(): boolean {
        return this.authenticated;
    }

    // 未登录时返回0;
    get authenticatedUserId(){
        return this._authenticatedUserId;
    }
    set authenticatedUserId(jwtUserId:number){
        this._authenticatedUserId = jwtUserId;
    }

    hasAnyAuthority(authorities: string[]): boolean {
        // console.log("Principal.hasAnyAuthority -> ", this.authenticated,this.userIdentity);
        if (!(this.authenticated&&this.userIdentity&&this.userIdentity.authorities)) return false;

        let userAuthorities = this.userIdentity.authorities;
        if(!Array.isArray(userAuthorities)) userAuthorities = [userAuthorities];

        if(!authorities) authorities = [];
        if(!Array.isArray(authorities)) authorities = [authorities];

        return userAuthorities.some(authority=>{
            // console.log(authority, authorities);
            return authority == "ROLE_ADMIN"||authorities.indexOf(authority)!=-1;
        });
    }
    hasAuthority(authority: string): boolean {
        return this.hasAnyAuthority([authority]);
    }

    identity(force?: boolean): Promise<any> {
        if (force === true){
            this.userIdentity = undefined;
            this.authenticate(null);
        }

        if (this.userIdentity) return Promise.resolve(this.userIdentity);
        if (this.userIdentityPromise) return this.userIdentityPromise;

        this.userIdentityPromise = this.account.get().toPromise().then(account=> {
            this.authenticate(account);
            return account;
        }).catch(error => {
            this.authenticate(null);
            return null;
        });
        return this.userIdentityPromise;
    }
}
